import React, { useEffect, useState } from "react";
import ReadyOperationCard from "./ReadyOperationCard/ReadyOperationCard";
import UnavailableOperationCard from "./UnavailableOperationCard/UnavailableOperationCard";
import { Button } from "react-bootstrap";
import CompleteOperationCard from "./CompleteOperationCard/CompleteOperationCard";
import { getEquipmentGroup } from "../../../../api/enterprise"; // Импорт функции
import ColorPicker from "./ColorPicker";
import { useTimeline } from "../../context/TimelineProvider";
import { fetchEquipment, fetchGetOrderItem, fetchProductPlan } from "../../api";
import moment from "moment";
import { notifyError } from "../../../../utils/toasts";
import { useTimelineMethods } from "../Timeline/hooks/hooks";
import MUIButton from "../../../../UI/Button/Button";

function OperationForm({ divisionId }) {
  const [equipmentGroups, setEquipmentGroups] = useState([]);

  const {
    deleteSelectedSegment,
    selectedSegment,
    addGroups,
    addSegments,
    selectedOrderItemId: orderItemId,
    orderFormData,
    orderFormColor,
    addOrderFormData,
    addOrderFormColor,
    updateHash,
  } = useTimeline();

  const { resetTimeline } = useTimelineMethods();

  async function getProductData() {
    try {
      const response = await fetchProductPlan({ divisionId }); // Асинхронный вызов
      const newHash = response?.data?.hash;
      if (newHash) {
        updateHash(response.data.hash); // Обновление хэша

        // Перезагружаем данные
        if (response.status === 200) {
          const newEquipment = await fetchEquipment({ divisionId });

          const newSegments = response.data.segments;

          resetTimeline();

          addGroups(
            newEquipment.data.map((eqItem) => ({
              id: eqItem.equipment_id,
              title: eqItem.name,
              height: 50,
              status: eqItem.status,
            }))
          );

          addSegments(
            newSegments.map((plan) => ({
              id: plan.segment_id,
              group: plan.equipment_id,
              title: plan.operation_name,
              start_time: moment(plan.start_time),
              end_time: moment(plan.end_time),
              order: plan.order_name,
              orderItemId: plan.order_item_id,
              quantity: plan.operation_quantity,
              style: {
                background: plan.order_color ?? "green",
                minHeight: "50px",
              },
            }))
          );
        }
      } else {
        console.log("No new hash received");
      }
    } catch (error) {
      console.error("Error fetching product plan:", error);
    }
  }

  const handleDeleteSegment = async () => {
    await deleteSelectedSegment();

    resetTimeline();

    await getProductData();
  };

  useEffect(() => {
    if (orderItemId) {
      // Загружаем данные с API для выбранного order_item_id
      fetchGetOrderItem(orderItemId).then((response) => {
        addOrderFormData(response?.data);
        addOrderFormColor(response?.data.order_color || "#FFFFFF");
      });
    }
  }, [orderItemId, selectedSegment]);

  // Загружаем данные о группах оборудования с помощью getEquipmentGroup
  useEffect(() => {
    const fetchGroups = async () => {
      try {
        const groups = await getEquipmentGroup(divisionId);
        setEquipmentGroups(groups);
      } catch (error) {
        notifyError(error?.response?.data?.message || error.message);
      }
    };

    fetchGroups();
  }, [divisionId]);

  if (!orderFormData) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "calc(100vh - 165px)",
        }}
      >
        <div>Загрузка...</div>
        <MUIButton onClick={handleDeleteSegment}>
          <i className="fas fa-plus">Удалить сегмент</i>
        </MUIButton>
      </div>
    );
  }

  const {
    operations,
    order_name,
    // order_color,
    nomenclature_name,
    nomenclature_quantity,
    order_id,
  } = orderFormData;

  // TODO: Вынести в api
  // Обработчик изменения цвета
  const handleColorChange = (color) => {
    addOrderFormColor(color.hex);

    // Подготовка данных для отправки
    const payload = {
      order_id: order_id, // Используем order_id из данных заказа
      color_code: color.hex,
    };

    // Отправка POST-запроса
    fetch(
      "http://qcan-dev.smart-era.com:8001/cl/v1/production-plan/order/color",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Ошибка сети");
        }
        return response.json();
      })
      .then((data) => {
        console.log("Цвет успешно обновлен:", data);
      })
      .catch((error) => {
        notifyError(error?.response?.data?.message || error.message);
      });
  };

  return (
    <div
      className="operation-form"
      style={{
        backgroundColor: orderFormColor,
        height: "calc(100vh - 165px)",
        overflowY: "auto",
      }}
    >
      <div
        className="order-header p-3 mb-3"
        style={{ border: `2px solid ${orderFormColor}`, borderRadius: "8px" }}
      >
        <h2>{order_name}</h2>
        <h3>{nomenclature_name}</h3>
        <p>
          <strong>Количество:</strong> {nomenclature_quantity}
          <ColorPicker color={orderFormColor} onChange={handleColorChange} />
        </p>
      </div>

      {operations && operations.length > 0 ? ( // Проверяем наличие операций
        operations.map((operation) => {
          switch (operation.operation_status) {
            case "ready":
              return (
                <ReadyOperationCard
                  key={operation.operation_id}
                  operation={operation}
                  orderItemId={orderFormData.order_item_id}
                  divisionId={divisionId}
                  equipmentGroups={equipmentGroups} // Передаем группы оборудования
                />
              );
            case "unavailable":
              return (
                <UnavailableOperationCard
                  key={operation.operation_id}
                  operation={operation}
                />
              );
            case "complete":
              return (
                <CompleteOperationCard
                  key={operation.operation_id}
                  operation={operation}
                />
              );
            default:
              return null;
          }
        })
      ) : (
        <div>Операции не найдены</div>
      )}

      <MUIButton onClick={handleDeleteSegment}>
        <i className="fas fa-plus">Удалить сегмент</i>
      </MUIButton>
    </div>
  );
}

export default OperationForm;
